module.exports = __webpack_public_path__ + "img/img05.b6475e8e.svg";